import { render, staticRenderFns } from "./bill-general-revision.vue?vue&type=template&id=179b9517&"
import script from "./bill-general-revision.vue?vue&type=script&lang=js&"
export * from "./bill-general-revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports